<template>
  <div v-if="user!==null">
    <b-row>
      <b-col lg="5" md="3">
          <DoctorDetailsTable :user="this.user"></DoctorDetailsTable>
          <PaymentsHistory :doctor="this.user.doctor"></PaymentsHistory>
      </b-col>
      <b-col>
        <CheckupHistory :doctor="this.user.doctor"></CheckupHistory>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import DoctorService from '@/services/admin/doctor.service'
import DoctorDetailsTable from "@/pages/admin/Doctor/doctorDetails/components/DoctorDetailsTable";
import PaymentsHistory from "@/components/admin/PaymentsHistory/PaymentsHistory";
import CheckupHistory from "@/components/admin/CheckupHistory/CheckupHistory";

export default {
  name: "DoctorDetails",
  components:{
    DoctorDetailsTable,
    PaymentsHistory,
    CheckupHistory
  },
  data() {
    return {
      user: null,
    };
  },
  methods:{

  },
  mounted() {
    var doctor_id= window.location.href.split('=')[1];
    DoctorService.fetchDoctorById(doctor_id)
    .then((response) => {
      if(response.status === 200){
        this.user= response.data;
        // this.getpatientcheckuphistory(this.user.doctor.id);
        //console.log(this.user.doctor);
      }
    })
    .catch((e) => {
        console.log(e);
    })


  }
}
</script>

<style scoped>

</style>